module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/small_cover-0ce6fa.png";